module.exports = __webpack_public_path__ + "media/images/modules/root_on_talkport/step1-fc57f5b3ba86fabc7e8331a792415057.png";